module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/pictogram-house-with-chimney-edf5070dcdfad98614c13c082327b652.svg";